<template>
  <div>
    <div class="d-flex justify-center pt-3">
      <div class="_temp_list" v-if="!loading && section">
        <on-module />
        <v-card
          class="rounded_max"
          flat
          style="overflow: hidden"
          min-height="150px"
        >
          <div class="strip" :style="`background:${section.color}`"></div>

          <div class="px-5 py-3" v-if="dataSet">
            <h3 class="mb-2">{{ dataSet.title }}</h3>
            <p class="default_txt" v-html="dataSet.description"></p>
          </div>
          <div class="pa-2 d-flex justify-end">
            <p class="default_txt">{{ msg }}</p>
          </div>
        </v-card>

        <!-- DETAIL AND DUE -->
        <v-card class="rounded_max pa-3 mt-3" flat>
          <div class="d-flex align-start">
            <v-icon class="mr-2" color="var(--g)"
              >mdi-information-outline</v-icon
            >
            <h3>Detail about project</h3>
          </div>
          <div class="conditional_left">
            <p v-html="detail.about"></p>
          </div>
          <v-card
            class="rounded-lg d-flex align-center pa-2"
            flat
            color="#00634133"
          >
            <v-icon color="var(--g)" class="mr-2"
              >mdi-calendar-clock-outline</v-icon
            >
            <p class="ma-0 mr-2 color_default">Deadline :</p>
            <b class="color_default">
              {{ $date(detail.deadline).format("dddd DD, MMMM, YYYY") }}
            </b>
          </v-card>
        </v-card>
        <!-- LINK PROJECT -->
        <!-- <v-card class="rounded_max pa-3 mt-3" flat>
          <div class="d-flex align-start">
            <v-icon class="mr-2" color="var(--g)">mdi-link</v-icon>
            <h3>Link for your project</h3>
          </div>
          <div class="conditional_left">
            <p>
              This is a link to fill out the jotform according to the category.
              Each category will be available if you have completed the previous
              step
            </p>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <a
                  :href="detail.link_proposal"
                  class="no_decoration"
                  target="_blank"
                >
                  <div class="link_temp">
                    <b class="color_default">Link Proposal</b>
                  </div>
                </a>
              </v-col>
              <v-col cols="12" sm="6" md="4" v-if="dataSet.isProgressAvail">
                <a
                  :href="detail.link_progress"
                  class="no_decoration"
                  target="_blank"
                >
                  <div class="link_temp">
                    <b class="color_default">Link Progress Report</b>
                  </div>
                </a>
              </v-col>
              <v-col cols="12" sm="6" md="4" v-if="!dataSet.isProgressAvail">
                <div class="unlink_temp">
                  <b style="color: #99c1b4">Link Progress Report</b>
                </div>
              </v-col>
              <v-col cols="12" sm="6" md="4" v-if="dataSet.isFinalAvail">
                <a
                  :href="detail.link_finish"
                  class="no_decoration"
                  target="_blank"
                >
                  <div class="link_temp">
                    <b class="color_default">Link Final Report</b>
                  </div>
                </a>
              </v-col>
              <v-col cols="12" sm="6" md="4" v-if="!dataSet.isFinalAvail">
                <div class="unlink_temp">
                  <b style="color: #99c1b4">Link Final Report</b>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card> -->

        <!-- STATIC ANOUNC -->
        <v-card
          class="rounded_max pa-3 mt-3"
          flat
          color="#00634133"
          v-if="submissionProgress"
        >
          <div class="d-flex align-start">
            <v-icon class="mr-2 mt-1" color="var(--g)"
              >mdi-information-outline</v-icon
            >
            <div v-if="!dataSet.isProgressAvail">
              <h3>The proposal is being reviewed by the administrator</h3>
              <p class="small_txt ma-0">
                You will receive a notification if administrator already
                reviewed your proposal
              </p>
            </div>
            <div v-if="dataSet.isProgressAvail && !dataSet.isFinalAvail">
              <h3>Congratulations! Now you enter the progress report</h3>
            </div>
            <div v-if="dataSet.isFinalAvail">
              <h3>Congratulations! Now you enter the final report</h3>
            </div>
          </div>
        </v-card>

        <!-- UPLOAD PROPOSAL -->
        <v-card class="rounded_max pa-3 mt-3" flat v-if="!submissionProgress">
          <div class="d-flex align-start">
            <v-icon class="mr-2" color="var(--g)">mdi-tray-arrow-up</v-icon>
            <div>
              <h3>Submit your proposal</h3>
              <p>Upload your proposal to fulfil next step of this project.</p>
              <v-btn
                color="var(--g)"
                class="text-capitalize rounded-lg"
                dark
                depressed
                @click="uploadProposal"
              >
                Submit Proposal
              </v-btn>
            </div>
          </div>
        </v-card>
        <!-- PROGRESS -->
        <v-card class="rounded_max pa-3 mt-3" flat v-if="submissionProgress">
          <div class="d-flex align-center">
            <v-icon class="mr-2" color="var(--g)">mdi-timeline-check</v-icon>
            <h3>Your Progress - {{ dataSubmission.additional_info.title }}</h3>
          </div>
          <div class="conditional_left">
            <p>You can watch progress of your proposal below</p>
            <div class="d-flex justify-end">
              <v-btn
                class="text-capitalize mr-2"
                depressed
                outlined
                dark
                @click="viewHistory"
                color="var(--g)"
                >History Submission</v-btn
              >
              <v-hover v-slot="{ hover }">
                <v-btn
                  @click="fetchData(false)"
                  dark
                  color="var(--g)"
                  depressed
                  class="rounded-lg text-capitalize"
                >
                  <v-icon>mdi-reload</v-icon>
                  <v-expand-x-transition>
                    <span class="ml-2" v-if="hover"> Reload</span>
                  </v-expand-x-transition>
                </v-btn>
              </v-hover>
            </div>
            <v-card class="mt-1" outlined>
              <v-timeline align-top dense>
                <v-timeline-item
                  v-for="(item, i) in submissionProgress.form"
                  :key="i"
                  :color="
                    item.extend.status == true
                      ? '#006341'
                      : item.extend.status == 'approved'
                      ? '#006341'
                      : item.extend.status == 'declined'
                      ? 'red'
                      : item.extend.status == 'revision'
                      ? 'orange'
                      : '#757575'
                  "
                  :icon="
                    item.extend.status == true
                      ? 'mdi-check'
                      : item.extend.status == 'approved'
                      ? 'mdi-check'
                      : item.extend.status == 'declined'
                      ? 'mdi-close'
                      : item.extend.status == 'revision'
                      ? 'mdi-minus'
                      : 'mdi-progress-clock'
                  "
                  small
                  fill-dot
                >
                  <v-expansion-panels accordion flat :disabled="!item.status">
                    <v-expansion-panel>
                      <v-expansion-panel-header class="pa-0"
                        ><div>
                          <b>{{ item.title }}</b>
                          <div>
                            <p v-if="item.date" class="default_txt mt-1">
                              {{
                                $date(item.date).format("DD, MMMM, YYYY HH:mm")
                              }}
                            </p>
                            <v-icon small v-else class="mt-1">
                              mdi-progress-clock
                            </v-icon>
                          </div>
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-card class="pa-2" flat color="#00634166">
                          <div v-if="item.key == 'submit'">
                            <h3 class="color_default">
                              Proposal has been submitted
                            </h3>
                            <p class="color_default">
                              The proposal has been sent by the leader at
                              {{
                                $date(item.date).format("DD, MMMM, YYYY HH:mm")
                              }}
                            </p>
                          </div>
                          <div v-if="item.key == 'review_navigator'">
                            <div v-if="dataSubmission.approval_council_at">
                              <div class="d-flex align-start">
                                <v-icon color="var(--g)" class="mr-1"
                                  >mdi-circle-medium</v-icon
                                >

                                <b class="color_default">Status</b>
                              </div>
                              <v-chip
                                dark
                                class="conditional_left mb-3"
                                label
                                :color="
                                  item.extend.status == 'approved'
                                    ? '#006341'
                                    : item.extend.status == 'declined'
                                    ? 'red'
                                    : item.extend.status == 'revision'
                                    ? 'orange'
                                    : '#757575'
                                "
                              >
                                <v-icon left>
                                  {{
                                    item.extend.status == "approved"
                                      ? "mdi-check"
                                      : item.extend.status == "declined"
                                      ? "mdi-close"
                                      : item.extend.status == "revision"
                                      ? "mdi-minus"
                                      : "mdi-progress-clock"
                                  }}
                                </v-icon>
                                {{ item.extend.status }}
                              </v-chip>
                              <div class="d-flex align-start">
                                <v-icon color="var(--g)" class="mr-1"
                                  >mdi-card-text-outline</v-icon
                                >
                                <b class="color_default">Notes</b>
                              </div>
                              <div class="conditional_left">
                                <v-card outlined class="pa-2">
                                  <p class="default_txt">
                                    {{ item.text }}
                                  </p>
                                </v-card>
                                <v-btn
                                  v-if="lastData.approval_admin == 'revision'"
                                  @click="updateProposal(item)"
                                  dark
                                  color="var(--g)"
                                  depressed
                                  class="rounded-lg text-capitalize mt-3"
                                  >Update</v-btn
                                >
                              </div>
                            </div>
                            <div v-else>
                              <h3 class="color_default">
                                {{ item.text }}
                              </h3>
                            </div>
                          </div>
                          <div v-if="item.key == 'review_tf'">
                            <div v-if="dataSubmission.approval_admin_at">
                              <div class="d-flex align-start">
                                <v-icon color="var(--g)" class="mr-1"
                                  >mdi-circle-medium</v-icon
                                >
                                <b class="color_default">Status</b>
                              </div>
                              <v-chip
                                class="conditional_left mb-3"
                                dark
                                label
                                :color="
                                  item.extend.status == 'approved'
                                    ? '#006341'
                                    : item.extend.status == 'declined'
                                    ? 'red'
                                    : item.extend.status == 'revision'
                                    ? 'orange'
                                    : '#757575'
                                "
                              >
                                <v-icon left>
                                  {{
                                    item.extend.status == "approved"
                                      ? "mdi-check"
                                      : item.extend.status == "declined"
                                      ? "mdi-close"
                                      : item.extend.status == "revision"
                                      ? "mdi-minus"
                                      : "mdi-progress-clock"
                                  }}
                                </v-icon>
                                {{ item.extend.status }}
                              </v-chip>
                              <div class="d-flex align-start">
                                <v-icon color="var(--g)" class="mr-1"
                                  >mdi-card-text-outline</v-icon
                                >
                                <b class="color_default">Notes</b>
                              </div>
                              <v-card outlined class="pa-2 conditional_left">
                                <p class="default_txt">
                                  {{ item.text }}
                                </p>
                              </v-card>
                              <v-btn
                                v-if="lastData.approval_admin == 'revision'"
                                @click="updateProposal(item)"
                                dark
                                color="var(--g)"
                                depressed
                                class="rounded-lg text-capitalize mt-3"
                                >Update</v-btn
                              >
                            </div>
                            <div v-else>
                              <h3 class="color_default">
                                {{ item.text }}
                              </h3>
                            </div>
                          </div>
                          <div v-if="item.key == 'progress'">
                            <div v-if="!item.extend.status">
                              <v-card outlined class="pa-3">
                                <b
                                  >Congratulations! Now you enter the progress
                                  report.</b
                                >
                              </v-card>
                              <v-btn
                                @click="updateProgress()"
                                dark
                                color="var(--g)"
                                depressed
                                class="rounded-lg text-capitalize mt-3"
                                >Report</v-btn
                              >
                            </div>
                            <div v-else class="d-flex align-center">
                              <v-icon color="var(--g)" class="mr-2"
                                >mdi-file-check</v-icon
                              >
                              <h3 class="color_default">
                                The progress report has been sent
                              </h3>
                            </div>
                          </div>
                          <div v-if="item.key == 'finals'">
                            <div v-if="!item.extend.status">
                              <v-card outlined class="pa-3">
                                <b>{{ item.text }}</b>
                              </v-card>
                              <v-btn
                                @click="updateFinalReport()"
                                dark
                                color="var(--g)"
                                depressed
                                class="rounded-lg text-capitalize mt-3"
                                >Report</v-btn
                              >
                            </div>
                            <div v-else class="d-flex align-center">
                              <v-icon color="var(--g)" class="mr-2"
                                >mdi-file-check</v-icon
                              >
                              <h3 class="color_default">
                                The Final report has been sent
                              </h3>
                            </div>
                          </div>
                          <div v-if="item.key == 'assignment'">
                            <div v-if="!item.extend.status">
                              <v-card outlined class="pa-3">
                                <b>{{ item.text }}</b>
                              </v-card>
                              <v-btn
                                @click="finalAssignment()"
                                dark
                                color="var(--g)"
                                depressed
                                class="rounded-lg text-capitalize mt-3"
                                >Submit</v-btn
                              >
                            </div>
                            <div v-else class="d-flex align-center">
                              <v-icon color="var(--g)" class="mr-2"
                                >mdi-file-check</v-icon
                              >
                              <h3 class="color_default">
                                The Final assignment has been sent
                              </h3>
                            </div>
                          </div>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-timeline-item>
              </v-timeline>
            </v-card>
          </div>
          <v-overlay
            :absolute="true"
            color="white"
            opacity="1"
            :value="progress"
          >
            <v-progress-circular
              indeterminate
              class="mr-2"
              color="#006341"
            ></v-progress-circular>
            <b class="color_default">Loading...</b>
          </v-overlay>
        </v-card>
      </div>

      <div v-if="loading" class="_temp_list">
        <v-row no-gutters>
          <v-col cols="12">
            <div class="pb-3">
              <v-skeleton-loader
                type="article"
                class="rounded_max mb-2"
              ></v-skeleton-loader>
              <v-skeleton-loader
                type="list-item-avatar-three-line"
                class="rounded_max mb-2"
              ></v-skeleton-loader>
              <v-skeleton-loader
                type="image"
                class="rounded_max mb-2"
              ></v-skeleton-loader>
              <v-skeleton-loader
                type="list-item-three-line"
                class="rounded_max mb-2"
              ></v-skeleton-loader>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
    <!-- CREATE QUIZ -->
    <div class="pa-3">
      <v-snackbar v-model="saving" left :timeout="-1">
        {{ msg }}
      </v-snackbar>
      <dialog-large
        :d_large="d_large"
        @refetch="fetchData"
        @close="d_large = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
      <dialog-medium
        :d_create="d_create"
        @refetch="fetchData"
        @close="d_create = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
      <dialog-small
        :d_small="d_small"
        @refetch="fetchData"
        @close="d_small = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
      <history-submission-module
        :d_his="d_his"
        @close="d_his = false"
        :inventory="inventory"
        :title="d_title"
      />
    </div>
  </div>
</template>

<script>
import FormMaterial from "../formDetail/formMaterial.vue";
import ListMemberGroupScholar from "../../../group/scholar/listMemberGroupScholar.vue";
import OnModule from "../../../../components/course/breadcrumbs/onModule.vue";
import HistorySubmissionModule from "../response/modal/historySubmissionModule.vue";
export default {
  components: {
    FormMaterial,
    ListMemberGroupScholar,
    OnModule,
    HistorySubmissionModule,
  },
  name: "moduleIndieProject",

  data() {
    return {
      loading: true,
      progress: false,
      loadMember: false,
      dataSet: null,
      detail: null,
      member: null,
      submissionProgress: null,
      dataSubmission: null,
      section: null,
      msg: "",
      d_large: false,
      d_his: false,
      d_create: false,
      d_small: false,
      inventory: null,
      d_type: "",
      d_title: "",
      isUpdate: false,
      updating: false,
      saving: false,
      err: "",
      tab: null,
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        [{ color: [] }],
      ],
      items: [
        {
          color: "#00634166",
          icon: "mdi-check-circle-outline",
        },
        {
          color: "#00634166",
          icon: "mdi-check-circle-outline",
        },
        {
          color: "#00634166",
          icon: "mdi-check-circle-outline",
        },
        {
          color: "#00634166",
          icon: "mdi-check-circle-outline",
        },
      ],
      lastData: null,
    };
  },

  mounted() {
    this.fetchSection();
  },
  methods: {
    fetchSection() {
      this.loading = true;
      let data = {
        path: `manage/course/section?filter[id]=${this.$route.params.idSection}`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          this.section = data.data[0];
          this.fetchData(true);
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    fetchData(first) {
      let module = this.$route.params.idModule;
      let instance = this.$route.params.idInstance;
      if (first) {
        this.loading = true;
      } else {
        this.progress = true;
      }
      let data = {
        path: `scholar/course/section/module/${module}/${instance}`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          this.dataSet = data.data;

          if (data.submission) {
            this.dataSubmission = data.submission;
            this.lastData = this.dataSubmission.submission[0].history;
            this.getSubmission();
          } else {
            this.loading = false;
          }
          if (data.detail) {
            this.detail = data.detail;
            this.loading = false;
          }
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    getSubmission() {
      let instance = this.$route.params.idInstance;
      this.progress = true;

      let data = {
        path: `scholar/course/project/individual/submission/progress?course_individu_project_id=${instance}`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          this.submissionProgress = data;
          data.form.forEach((el) => {
            if (el.key == "progress") {
              this.dataSet["isProgressAvail"] = el.status;
            } else if (el.key == "finals") {
              this.dataSet["isFinalAvail"] = el.status;
            }
          });

          this.progress = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.progress = false;
        });
    },

    uploadProposal() {
      this.inventory = {
        type: "indie",
      };
      this.d_type = "c_proposal";
      this.d_title = "Submit Proposal";
      this.d_large = true;
    },
    updateProposal(item) {
      this.inventory = {
        notes: item.text,
        title: this.dataSubmission.additional_info.title,
        type: "indie",
      };
      this.d_type = "u_proposal";
      this.d_title = "Update Proposal";
      this.d_large = true;
    },
    updateProgress() {
      this.inventory = {
        title: this.dataSubmission.additional_info.title,
        type: "indie",
      };
      this.d_type = "u_progresreport";
      this.d_title = "Report Progress Proposal";
      this.d_large = true;
    },
    updateFinalReport() {
      this.inventory = {
        title: this.dataSubmission.additional_info.title,
        type: "indie",
      };
      this.d_type = "finalreport";
      this.d_title = "Submit Final Assignment";
      this.d_large = true;
    },
    finalAssignment() {
      this.inventory = {
        title: this.dataSubmission.additional_info.title,
        type: "indie",
      };
      this.d_type = "finalassignment";
      this.d_title = "Submit Final Assignment";
      this.d_large = true;
    },
    viewHistory() {
      this.inventory = this.dataSubmission.submission;
      this.d_title = "History Submission";
      this.d_his = true;
    },
  },
};
</script>

<style scoped>
.strip {
  padding: 3px;
  height: 10px;
  width: 100%;
  border-radius: 0 !important;
}
.card_gb {
  position: relative;
  overflow: hidden;
}
.icon_gb {
  position: absolute;
  right: -20px;
  bottom: -20px;
}
.link_temp {
  height: 85px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #00634166;
  border: 1px #006341 dashed;
  border-radius: 10px;
}
.unlink_temp {
  height: 85px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #d6e6e1;
  border: 1px #006341 dashed;
  border-radius: 10px;
}
.v-expansion-panel-content >>> .v-expansion-panel-content__wrap {
  padding: 10px 10px 0 0 !important;
}
.v-expansion-panel-header {
  min-height: 20px !important;
}
.theme--light.v-timeline:before {
  background: #d8e5e2;
  width: 15px;
  margin-left: -6px;
}
</style>
